import React from 'react';
import {connect} from 'react-redux';
import CartExcursionEntryItinerary from './CartExcursionEntryItinerary';
import CartExcursionEntryBooking from './CartExcursionEntryBooking';
import {flattenExcursions} from '../../utils/cartUtils';


class CartElements extends React.Component {
    cartElementComponents = {
        itinerary: CartExcursionEntryItinerary,
        booking: CartExcursionEntryBooking,
    };

    getExcursions = (itineraryId = null) => {
        //nothing in the cart, return empty array
        if(this.props.cartExcursions === null) {
            return [];
        }

        //looking for all cart elements
        if(!itineraryId) {
            return flattenExcursions(this.props.cartExcursions);
        }

        //looking for cart elements belonging to one itinerary
        let cartEntries = {};
        cartEntries[itineraryId] = this.props.cartExcursions[itineraryId];
        return flattenExcursions(cartEntries);
    };


    render() {
        const CartElementComponent = this.cartElementComponents[this.props.cartType];
        const excursions = this.getExcursions(this.props.itineraryId);

        return (
            <div className="w-full my-2 text-grey-darker">
                {excursions.map((excursion) =>
                    <CartElementComponent
                        key={`${excursion.excursionId}-${excursion.state || "default"}`}
                        excursion={excursion}
                    />
                )}
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    switch (ownProps.cartType) {
        case 'booking':
            return {
                cartExcursions: state.bookings.excursions,
            };
        default:
            return {
                cartExcursions: state.cart.excursions,
            };
    }
}

export default connect(mapStateToProps) (CartElements);